/******/ var __webpack_modules__ = ({

/***/ 2375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $b: function() { return /* binding */ SlideshowSelectEvent; }
/* harmony export */ });
/* unused harmony exports ThemeEvents, VariantSelectedEvent, VariantUpdateEvent, CartAddEvent, CartUpdateEvent, CartErrorEvent, QuantitySelectorUpdateEvent, DiscountUpdateEvent, MediaStartedPlayingEvent, ZoomMediaSelectedEvent, MegaMenuHoverEvent, FilterUpdateEvent */
/**
 * @namespace ThemeEvents
 * @description A collection of theme-specific events that can be used to trigger and listen for changes anywhere in the theme.
 * @example
 * document.dispatchEvent(new VariantUpdateEvent(variant, sectionId, { html }));
 * document.addEventListener(ThemeEvents.variantUpdate, (e) => { console.log(e.detail.variant) });
 */
class ThemeEvents {
  /** @static @constant {string} Event triggered when a variant is selected */
  static variantSelected = 'variant:selected';
  /** @static @constant {string} Event triggered when a variant is changed */
  static variantUpdate = 'variant:update';
  /** @static @constant {string} Event triggered when the cart items or quantities are updated */
  static cartUpdate = 'cart:update';
  /** @static @constant {string} Event triggered when a cart update fails */
  static cartError = 'cart:error';
  /** @static @constant {string} Event triggered when a media (video, 3d model) is loaded */
  static mediaStartedPlaying = 'media:started-playing';
  // Event triggered when quantity-selector value is changed
  static quantitySelectorUpdate = 'quantity-selector:update';
  /** @static @constant {string} Event triggered when a predictive search is expanded */
  static megaMenuHover = 'megaMenu:hover';
  /** @static @constant {string} Event triggered when a zoom dialog media is selected */
  static zoomMediaSelected = 'zoom-media:selected';
  /** @static @constant {string} Event triggered when a discount is applied */
  static discountUpdate = 'discount:update';
  /** @static @constant {string} Event triggered when changing collection filters */
  static FilterUpdate = 'filter:update';
}

/**
 * Event fired when a variant is selected
 * @extends {Event}
 */
class VariantSelectedEvent extends Event {
  /**
   * Creates a new VariantSelectedEvent
   * @param {Object} resource - The new variant object
   * @param {string} resource.id - The option value id
   */
  constructor(resource) {
    super(ThemeEvents.variantSelected, {
      bubbles: true
    });
    this.detail = {
      resource
    };
  }
}

/**
 * Event fired after a variant is updated
 * @extends {Event}
 */
class VariantUpdateEvent extends Event {
  /**
  * Creates a new VariantUpdateEvent
  * @param {Object} resource - The new variant object
  * @param {string} resource.id - The id of the variant
  * @param {boolean} resource.available - Whether the variant is available
  * @param {boolean} resource.inventory_management - Whether the variant has inventory management
  * @param {string} [resource.sku] - The SKU of the variant
  * @param {Object} [resource.featured_media] - The featured media of the variant
  * @param {string} [resource.featured_media.id] - The id of the featured media
  * @param {Object} [resource.featured_media.preview_image] - The preview image of the featured media
  * @param {string} [resource.featured_media.preview_image.src] - The src URL of the preview image
  * @param {string} sourceId - The id of the element the action was triggered from
  * @param {Object} data - Additional event data
  * @param {Document} data.html - The new document fragment for the variant
  * @param {string} data.productId - The product ID of the updated variant, used to ensure the correct product form is updated
  * @param {Object} [data.newProduct] - If a new product was loaded as part of the variant update (combined listing)
  * @param {string} data.newProduct.id - The id of the new product
  * @param {string} data.newProduct.url - The url of the new product
  */
  constructor(resource, sourceId, data) {
    super(ThemeEvents.variantUpdate, {
      bubbles: true
    });
    this.detail = {
      resource: resource || null,
      sourceId,
      data: {
        html: data.html,
        productId: data.productId,
        newProduct: data.newProduct
      }
    };
  }
}

/**
 * Event class for cart additions
 * @extends {Event}
 */
class CartAddEvent extends Event {
  /**
  * Creates a new CartAddEvent
  * @param {Object} [resource] - The new cart object
  * @param {string} [sourceId] - The id of the element the action was triggered from
  * @param {Object} [data] - Additional event data
  * @param {boolean} [data.didError] - Whether the cart operation failed
  * @param {string} [data.source] - The source of the cart update
  * @param {string} [data.productId] - The id of the product card that was updated
  * @param {number} [data.itemCount] - The number of items in the cart
  * @param {string} [data.variantId] - The id of the product variant that was added
  * @param {Record<string, string>} [data.sections] - The sections affected by the cart operation
  */
  constructor(resource, sourceId, data) {
    super(CartAddEvent.eventName, {
      bubbles: true
    });
    this.detail = {
      resource,
      sourceId,
      data: {
        ...data
      }
    };
  }
  static eventName = ThemeEvents.cartUpdate;
}

/**
 * Event class for cart updates
 * @extends {Event}
 */
class CartUpdateEvent extends Event {
  /**
  * Creates a new CartUpdateEvent
  * @param {Object} resource - The new cart object
  * @param {string} sourceId - The id of the element the action was triggered from
  * @param {Object} [data] - Additional event data
  * @param {boolean} [data.didError] - Whether the cart operation failed
  * @param {string} [data.source] - The source of the cart update
  * @param {string} [data.productId] - The id of the product card that was updated
  * @param {number} [data.itemCount] - The number of items in the cart
  * @param {string} [data.variantId] - The id of the product variant that was updated
  * @param {Record<string, string>} [data.sections] - The sections affected by the cart operation
  */
  constructor(resource, sourceId, data) {
    super(ThemeEvents.cartUpdate, {
      bubbles: true
    });
    this.detail = {
      resource,
      sourceId,
      data: {
        ...data
      }
    };
  }
}

/**
 * Event class for cart errors
 * @extends {Event}
 */
class CartErrorEvent extends Event {
  /**
  * Creates a new CartErrorEvent
  * @param {string} sourceId - The id of the element the action was triggered from
  * @param {string} message - A message from the server response
  * @param {Object} description - Description from the server response
  * @param {Object} errors - Errors from the server response
  */
  constructor(sourceId, message, description, errors) {
    super(ThemeEvents.cartError, {
      bubbles: true
    });
    this.detail = {
      sourceId,
      data: {
        message,
        errors,
        description
      }
    };
  }
}

/**
 * Event class for quantity-selector updates
 * @extends {Event}
 */
class QuantitySelectorUpdateEvent extends Event {
  /**
  * Creates a new QuantitySelectorUpdateEvent
  * @param {number} quantity - Quantity value
  * @param {number} [cartLine] - The id of the updated cart line
  */
  constructor(quantity, cartLine) {
    super(ThemeEvents.quantitySelectorUpdate, {
      bubbles: true
    });
    this.detail = {
      quantity,
      cartLine
    };
  }
}

/**
 * Event class for quantity-selector updates
 * @extends {Event}
 */
class DiscountUpdateEvent extends Event {
  /**
  * Creates a new DiscountUpdateEvent
  * @param {Object} resource - The new cart object
  * @param {string} sourceId - The id of the element the action was triggered from
  */
  constructor(resource, sourceId) {
    super(ThemeEvents.discountUpdate, {
      bubbles: true
    });
    this.detail = {
      resource,
      sourceId
    };
  }
}

/**
 * Event class for media playback starts
 * @extends {Event}
 */
class MediaStartedPlayingEvent extends Event {
  /**
  * Creates a new MediaStartedPlayingEvent
  * @param {HTMLElement} resource - The element containing the video that emitted the event
  */
  constructor(resource) {
    super(ThemeEvents.mediaStartedPlaying, {
      bubbles: true
    });
    this.detail = {
      resource
    };
  }
}

/**
 * @typedef {Object} SlideshowSelectEventData
 * @property {number} index
 * @property {string | null} id
 * @property {Element} slide
 * @property {number} previousIndex
 * @property {boolean} userInitiated
 * @property {'select' | 'scroll' | 'drag'} trigger
 */

class SlideshowSelectEvent extends Event {
  /**  @param {SlideshowSelectEventData} data */
  constructor(data) {
    super(SlideshowSelectEvent.eventName, {
      bubbles: true
    });
    this.detail = data;
  }

  /** @type {SlideshowSelectEventData} */
  detail;
  static eventName = 'slideshow:select';
}

/**
 * Event class for zoom dialog media selection
 * @extends {Event}
 */
class ZoomMediaSelectedEvent extends Event {
  /**
  * Creates a new ZoomMediaSelectedEvent
  * @param {number} index - The index of the selected media
  */
  constructor(index) {
    super(ThemeEvents.zoomMediaSelected, {
      bubbles: true
    });
    this.detail = {
      index
    };
  }
}

/**
 * Event class for mega menu hover being hovered over
 * @extends {Event}
 */
class MegaMenuHoverEvent extends Event {
  constructor() {
    super(ThemeEvents.megaMenuHover, {
      bubbles: true
    });
  }
}

/** Event class for facet filtering updates */
class FilterUpdateEvent extends Event {
  /** @param {URLSearchParams} queryParams */
  constructor(queryParams) {
    super(ThemeEvents.FilterUpdate, {
      bubbles: true
    });
    this.detail = {
      queryParams
    };
  }
  shouldShowClearAll() {
    return [...this.detail.queryParams.entries()].filter(([key]) => key.startsWith('filter.')).length > 0;
  }
}

/***/ }),

/***/ 2443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   u: function() { return /* binding */ Component; }
/* harmony export */ });
/* unused harmony export DeclarativeShadowElement */
/* harmony import */ var _theme_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6816);


/*
 * Declarative shadow DOM is only initialized on the initial render of the page.
 * If the component is mounted after the browser finishes the initial render,
 * the shadow root needs to be manually hydrated.
 */
class DeclarativeShadowElement extends HTMLElement {
  connectedCallback() {
    if (!this.shadowRoot) {
      const template = this.querySelector(':scope > template[shadowrootmode="open"]');
      if (!(template instanceof HTMLTemplateElement)) return;
      const shadow = this.attachShadow({
        mode: 'open'
      });
      shadow.append(template.content.cloneNode(true));
    }
  }
}

/**
 * @typedef {Record<string, Element | Element[] | undefined>} Refs
 */

/**
 * @template {Refs} T
 * @typedef {T & Refs} RefsType
 */

/**
 * Base class that powers our custom web components.
 *
 * Manages references to child elements with `ref` attributes and sets up mutation observers to keep
 * the refs updated when the DOM changes. Also handles declarative event listeners using.
 *
 * @template {Refs} [T=Refs]
 * @extends {DeclarativeShadowElement}
 */
class Component extends DeclarativeShadowElement {
  /**
  * An object holding references to child elements with `ref` attributes.
  *
  * @type {RefsType<T>}
  */
  refs = (/** @type {RefsType<T>} */{});

  /**
  * An array of required refs. If a ref is not found, an error will be thrown.
  *
  * @type {string[] | undefined}
  */
  requiredRefs;

  /**
  * Gets the root node of the component, which is either its shadow root or the component itself.
  *
  * @returns {(ShadowRoot | Component<T>)[]} The root nodes.
  */
  get roots() {
    return this.shadowRoot ? [this, this.shadowRoot] : [this];
  }

  /**
  * Called when the element is connected to the document's DOM.
  *
  * Initializes event listeners and refs.
  */
  connectedCallback() {
    super.connectedCallback();
    registerEventListeners();
    this.#updateRefs();
    (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_0__/* .requestIdleCallback */ .BB)(() => {
      for (const root of this.roots) {
        this.#mutationObserver.observe(root, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['ref'],
          attributeOldValue: true
        });
      }
    });
  }

  /**
  * Called when the element is re-rendered by the Section Rendering API.
  */
  updatedCallback() {
    this.#mutationObserver.takeRecords();
    this.#updateRefs();
  }

  /**
  * Called when the element is disconnected from the document's DOM.
  *
  * Disconnects the mutation observer.
  */
  disconnectedCallback() {
    this.#mutationObserver.disconnect();
  }

  /**
  * Updates the `refs` object by querying all descendant elements with `ref` attributes and storing references to them.
  *
  * This method is called to keep the `refs` object in sync with the DOM.
  */
  #updateRefs() {
    const refs = /** @type any */{};
    const elements = this.roots.reduce((acc, root) => {
      for (const element of root.querySelectorAll('[ref]')) {
        if (!this.#isDescendant(element)) continue;
        acc.add(element);
      }
      return acc;
    }, /** @type {Set<Element>} */new Set());
    for (const ref of elements) {
      const refName = ref.getAttribute('ref') ?? '';
      const isArray = refName.endsWith('[]');
      const path = isArray ? refName.slice(0, -2) : refName;
      if (isArray) {
        const array = Array.isArray(refs[path]) ? refs[path] : [];
        array.push(ref);
        refs[path] = array;
      } else {
        const existing = refs[path];
        const refIsDirectChild = ref.parentElement === this;
        const existingIsDirectChild = existing?.parentElement === this;
        if (existing !== undefined) {
          if (existingIsDirectChild && !refIsDirectChild) continue;
          if (!existingIsDirectChild && refIsDirectChild) {
            refs[path] = ref;
            continue;
          }
        }
        refs[path] = ref;
      }
    }
    if (this.requiredRefs?.length) {
      for (const ref of this.requiredRefs) {
        if (!(ref in refs)) {
          throw new MissingRefError(ref, this);
        }
      }
    }
    this.refs = /** @type {RefsType<T>} */refs;
  }

  /**
  * MutationObserver instance to observe changes in the component's DOM subtree and update refs accordingly.
  *
  * @type {MutationObserver}
  */
  #mutationObserver = new MutationObserver(mutations => {
    if (mutations.some(m => m.type === 'attributes' && this.#isDescendant(m.target) || m.type === 'childList' && [...m.addedNodes, ...m.removedNodes].some(this.#isDescendant))) {
      this.#updateRefs();
    }
  });

  /**
  * Checks if a given node is a descendant of this component.
  *
  * @param {Node} node - The node to check.
  * @returns {boolean} True if the node is a descendant of this component.
  */
  #isDescendant = node => getClosestComponent(getAncestor(node)) === this;
}

/**
 * Get the ancestor of a given node.
 *
 * @param {Node} node - The node to get the ancestor of.
 * @returns {Node | null} The ancestor of the node or null if none is found.
 */
function getAncestor(node) {
  if (node.parentNode) return node.parentNode;
  const root = node.getRootNode();
  if (root instanceof ShadowRoot) return root.host;
  return null;
}

/**
 * Recursively finds the closest ancestor that is an instance of `Component`.
 *
 * @param {Node | null} node - The starting node to search from.
 * @returns {HTMLElement | null} The closest ancestor `Component` instance or null if none is found.
 */
function getClosestComponent(node) {
  if (!node) return null;
  if (node instanceof Component) return node;
  if (node instanceof HTMLElement && node.tagName.toLowerCase().endsWith('-component')) return node;
  const ancestor = getAncestor(node);
  if (ancestor) return getClosestComponent(ancestor);
  return null;
}

/**
 * Initializes the event listeners for custom event handling.
 *
 * Sets up event listeners for specified events and delegates the handling of those events
 * to methods defined on the closest `Component` instance, based on custom attributes.
 */
let initialized = false;
function registerEventListeners() {
  if (initialized) return;
  initialized = true;
  const events = ['click', 'change', 'select', 'focus', 'blur', 'submit', 'input', 'keydown', 'keyup', 'toggle'];
  const shouldBubble = ['focus', 'blur'];
  const expensiveEvents = ['pointerenter', 'pointerleave'];
  for (const eventName of [...events, ...expensiveEvents]) {
    const attribute = `on:${eventName}`;
    document.addEventListener(eventName, event => {
      const element = getElement(event);
      if (!element) return;
      const proxiedEvent = event.target !== element ? new Proxy(event, {
        get(target, property) {
          if (property === 'target') return element;
          const value = Reflect.get(target, property);
          if (typeof value === 'function') {
            return value.bind(target);
          }
          return value;
        }
      }) : event;
      const value = element.getAttribute(attribute) ?? '';
      let [selector, method] = value.split('/');
      // Extract the last segment of the attribute value delimited by `?` or `/`
      // Do not use lookback for Safari 16.0 compatibility
      const matches = value.match(/([\/\?][^\/\?]+)([\/\?][^\/\?]+)$/);
      const data = matches ? matches[2] : null;
      const instance = selector ? selector.startsWith('#') ? document.querySelector(selector) : element.closest(selector) : getClosestComponent(element);
      if (!(instance instanceof Component) || !method) return;
      method = method.replace(/\?.*/, '');
      const callback = /** @type {any} */instance[method];
      if (typeof callback === 'function') {
        try {
          /** @type {(Event | Data)[]} */
          const args = [proxiedEvent];
          if (data) args.unshift(parseData(data));
          callback.call(instance, ...args);
        } catch (error) {
          console.error(error);
        }
      }
    }, {
      capture: true
    });
  }

  /** @param {Event} event */
  function getElement(event) {
    const target = event.composedPath?.()[0] ?? event.target;
    if (!(target instanceof Element)) return;
    if (target.hasAttribute(`on:${event.type}`)) {
      return target;
    }
    if (expensiveEvents.includes(event.type)) {
      return null;
    }
    return event.bubbles || shouldBubble.includes(event.type) ? target.closest(`[on\\:${event.type}]`) : null;
  }
}

/**
 * Parses a string to extract data based on a delimiter.
 *
 * @param {string} str - The string to parse.
 * @returns {Object|Array<string|number>|string} The parsed data.
 */
function parseData(str) {
  const delimiter = str[0];
  const data = str.slice(1);
  return delimiter === '?' ? Object.fromEntries(Array.from(new URLSearchParams(data).entries()).map(([key, value]) => [key, parseValue(value)])) : parseValue(data);
}

/**
 * @typedef {Object|Array<string|number>|string} Data
 */

/**
 * Parses a string value to its appropriate type.
 *
 * @param {string} str - The string to parse.
 * @returns {Data} The parsed value.
 */
function parseValue(str) {
  if (str === 'true') return true;
  if (str === 'false') return false;
  const maybeNumber = Number(str);
  if (!isNaN(maybeNumber) && str.trim() !== '') return maybeNumber;
  return str;
}

/**
 * Throws a formatted error when a required ref is not found in the component.
 */
class MissingRefError extends Error {
  /**
  * @param {string} ref
  * @param {Component} component
  */
  constructor(ref, component) {
    super(`Required ref "${ref}" not found in component ${component.tagName.toLowerCase()}`);
  }
}

/***/ }),

/***/ 6816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B5: function() { return /* binding */ viewTransition; },
/* harmony export */   BB: function() { return /* binding */ requestIdleCallback; },
/* harmony export */   GO: function() { return /* binding */ mediaQueryLarge; },
/* harmony export */   Oe: function() { return /* binding */ prefersReducedMotion; },
/* harmony export */   ck: function() { return /* binding */ scheduler; },
/* harmony export */   gX: function() { return /* binding */ center; },
/* harmony export */   kp: function() { return /* binding */ closest; },
/* harmony export */   nF: function() { return /* binding */ throttle; },
/* harmony export */   qE: function() { return /* binding */ clamp; },
/* harmony export */   sg: function() { return /* binding */ debounce; },
/* harmony export */   wo: function() { return /* binding */ preventDefault; }
/* harmony export */ });
/* unused harmony exports yieldToMainThread, isLowPowerDevice, supportsViewTransitions, startViewTransition, fetchConfig, normalizeString, onDocumentLoaded, onDocumentReady, removeWillChangeOnAnimationEnd, onAnimationEnd, isClickedOutside, isPointWithinElement, isMobileBreakpoint, isDesktopBreakpoint, isTouchDevice, start, getVisibleElements, getIOSVersion, preloadImage, TextComponent, resetShimmer, changeMetaThemeColor, getViewParameterValue, parseIntOrDefault, oncePerEditorSession, ResizeNotifier, setHeaderMenuStyle, calculateHeaderGroupHeight, updateAllHeaderCustomProperties */
/**
 * Request an idle callback or fallback to setTimeout
 * @returns {function} The requestIdleCallback function
 */
const requestIdleCallback = typeof window.requestIdleCallback == 'function' ? window.requestIdleCallback : setTimeout;

/**
 * Returns a promise that resolves after yielding to the main thread.
 * @see https://web.dev/articles/optimize-long-tasks#scheduler-yield
 */
const yieldToMainThread = () => {
  if ('yield' in scheduler) {
    // @ts-ignore - TypeScript doesn't recognize the yield method yet.
    return scheduler.yield();
  }
  return new Promise(resolve => {
    requestAnimationFrame(() => {
      setTimeout(resolve, 0);
    });
  });
};

/**
 * Tells if we are on a low power device based on the number of CPU cores and RAM
 * @returns {boolean} True if the device is a low power device, false otherwise
 */
function isLowPowerDevice() {
  return Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
}

/**
 * Check if the browser supports View Transitions API
 * @returns {boolean} True if the browser supports View Transitions API, false otherwise
 */
function supportsViewTransitions() {
  return typeof document.startViewTransition === 'function';
}

/**
 * The current view transition
 * @type {{ current: Promise<void> | undefined }}
 */
const viewTransition = {
  current: undefined
};

/**
 * Functions to run when a view transition of a given type is started
 * @type {{ [key: string]: () => Promise<(() => void) | undefined> }}
 */
const viewTransitionTypes = {
  'product-grid': async () => {
    const grid = document.querySelector('.product-grid');
    const productCards = /** @type {HTMLElement[]} */[...document.querySelectorAll('.product-grid .product-grid__item')];
    if (!grid || !productCards.length) return;
    await new Promise(resolve => requestIdleCallback(() => {
      const cardsToAnimate = getCardsToAnimate(grid, productCards);
      productCards.forEach((card, index) => {
        if (index < cardsToAnimate) {
          card.style.setProperty('view-transition-name', `product-card-${card.dataset.productId}`);
        } else {
          card.style.setProperty('content-visibility', 'hidden');
        }
      });
      resolve(null);
    }));
    return () => productCards.forEach(card => {
      card.style.removeProperty('view-transition-name');
      card.style.removeProperty('content-visibility');
    });
  }
};

/**
 * Starts a view transition
 * @param {() => void} callback The callback to call when the view transition starts
 * @param {string[]} [types] The types of view transition to use
 * @returns {Promise<void>} A promise that resolves when the view transition finishes
 */
function startViewTransition(callback, types) {
  // Check if the API is supported and transitions are desired
  if (!supportsViewTransitions() || isLowPowerDevice() || prefersReducedMotion()) {
    callback();
    return Promise.resolve();
  }

  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async resolve => {
    let cleanupFunctions = [];
    if (types) {
      for (const type of types) {
        if (viewTransitionTypes[type]) {
          const cleanupFunction = await viewTransitionTypes[type]();
          if (cleanupFunction) cleanupFunctions.push(cleanupFunction);
        }
      }
    }
    const transition = document.startViewTransition(callback);
    if (!viewTransition.current) {
      viewTransition.current = transition.finished;
    }
    if (types) types.forEach(type => transition.types.add(type));
    transition.finished.then(() => {
      viewTransition.current = undefined;
      cleanupFunctions.forEach(cleanupFunction => cleanupFunction());
      resolve();
    });
  });
}

/**
 * @typedef {{ [key: string]: string | undefined }} Headers
 */

/**
 * @typedef {Object} FetchConfig
 * @property {string} method
 * @property {Headers} headers
 * @property {string | FormData | undefined} [body]
 */

/**
 * Creates a fetch configuration object
 * @param {string} [type] The type of response to expect
 * @param {Object} [config] The config of the request
 * @param {FetchConfig['body']} [config.body] The body of the request
 * @param {FetchConfig['headers']} [config.headers] The headers of the request
 * @returns {RequestInit} The fetch configuration object
 */
function fetchConfig(type = 'json', config = {}) {
  /** @type {Headers} */
  const headers = {
    'Content-Type': 'application/json',
    Accept: `application/${type}`,
    ...config.headers
  };
  if (type === 'javascript') {
    headers['X-Requested-With'] = 'XMLHttpRequest';
    delete headers['Content-Type'];
  }
  return {
    method: 'POST',
    headers: (/** @type {HeadersInit} */headers),
    body: config.body
  };
}

/**
 * Creates a debounced function that delays calling the provided function (fn)
 * until after wait milliseconds have elapsed since the last time
 * the debounced function was invoked. The returned function has a .cancel()
 * method to cancel any pending calls.
 *
 * @template {(...args: any[]) => any} T
 * @param {T} fn The function to debounce
 * @param {number} wait The time (in milliseconds) to wait before calling fn
 * @returns {T & { cancel(): void }} A debounced version of fn with a .cancel() method
 */
function debounce(fn, wait) {
  /** @type {number | undefined} */
  let timeout;

  /** @param {...any} args */
  function debounced(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  }

  // Add the .cancel method:
  debounced.cancel = () => {
    clearTimeout(timeout);
  };
  return /** @type {T & { cancel(): void }} */debounced;
}

/**
 * Creates a throttled function that calls the provided function (fn) at most once per every wait milliseconds
 *
 * @template {(...args: any[]) => any} T
 * @param {T} fn The function to throttle
 * @param {number} delay The time (in milliseconds) to wait before calling fn
 * @returns {T & { cancel(): void }} A throttled version of fn with a .cancel() method
 */
function throttle(fn, delay) {
  let lastCall = 0;

  /** @param {...any} args */
  function throttled(...args) {
    const now = performance.now();
    // If the time since the last call exceeds the delay, execute the callback
    if (now - lastCall >= delay) {
      lastCall = now;
      fn.apply(this, args);
    }
  }
  throttled.cancel = () => {
    lastCall = performance.now();
  };
  return /** @type {T & { cancel(): void }} */throttled;
}

/**
 * A media query for reduced motion
 * @type {MediaQueryList}
 */
const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

/**
 * Check if the user prefers reduced motion
 * @returns {boolean} True if the user prefers reduced motion, false otherwise
 */
function prefersReducedMotion() {
  return reducedMotion.matches;
}

/**
 * Normalize a string
 * @param {string} str The string to normalize
 * @returns {string} The normalized string
 */
function normalizeString(str) {
  return str.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
}

/**
 * Check if the document is ready/loaded and call the callback when it is.
 * @param {() => void} callback The function to call when the document is ready.
 */
function onDocumentLoaded(callback) {
  if (document.readyState === 'complete') {
    callback();
  } else {
    window.addEventListener('load', callback);
  }
}

/**
 * Check if the DOM is ready and call the callback when it is.
 * This fires when the DOM is fully parsed but before all resources are loaded.
 * @param {() => void} callback The function to call when the DOM is ready.
 */
function onDocumentReady(callback) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback);
  } else {
    callback();
  }
}

/**
 * Removes will-change from an element after an animation ends.
 * Intended to be used as an animationend event listener.
 * @param {AnimationEvent} event The animation event.
 */
function removeWillChangeOnAnimationEnd(event) {
  const target = event.target;
  if (target && target instanceof HTMLElement) {
    target.style.setProperty('will-change', 'unset');
    target.removeEventListener('animationend', removeWillChangeOnAnimationEnd);
  }
}

/**
 * Wait for all animations to finish before calling the callback.
 * @param {Element | Element[]} elements The element(s) whose animations to wait for.
 * @param {() => void} [callback] The function to call when all animations are finished.
 * @param {Object} [options] The options to pass to `Element.getAnimations`.
 * @returns {Promise<void>} A promise that resolves when all animations are finished.
 */
function onAnimationEnd(elements, callback, options = {
  subtree: true
}) {
  const animations = Array.isArray(elements) ? elements.flatMap(element => element.getAnimations(options)) : elements.getAnimations(options);
  const animationPromises = animations.reduce((acc, animation) => {
    // Ignore ViewTimeline animations
    if (animation.timeline instanceof DocumentTimeline) {
      acc.push(animation.finished);
    }
    return acc;
  }, /** @type {Promise<Animation>[]} */[]);
  return Promise.allSettled(animationPromises).then(callback);
}

/**
 * Check if the click is outside the element.
 * @param {MouseEvent} event The mouse event.
 * @param {Element} element The element to check.
 * @returns {boolean} True if the click is outside the element, false otherwise.
 */
function isClickedOutside(event, element) {
  if (event.target instanceof HTMLDialogElement || !(event.target instanceof Element)) {
    return !isPointWithinElement(event.clientX, event.clientY, element);
  }
  return !element.contains(event.target);
}

/**
 * Check if a point is within an element.
 * @param {number} x The x coordinate of the point.
 * @param {number} y The y coordinate of the point.
 * @param {Element} element The element to check.
 * @returns {boolean} True if the point is within the element, false otherwise.
 */
function isPointWithinElement(x, y, element) {
  const {
    left,
    right,
    top,
    bottom
  } = element.getBoundingClientRect();
  return x >= left && x <= right && y >= top && y <= bottom;
}

/**
 * A media query for large screens
 * @type {MediaQueryList}
 */
const mediaQueryLarge = matchMedia('(min-width: 750px)');

/**
 * Check if the current breakpoint is mobile
 * @returns {boolean} True if the current breakpoint is mobile, false otherwise
 */
function isMobileBreakpoint() {
  return !mediaQueryLarge.matches;
}

/**
 * Check if the current breakpoint is desktop
 * @returns {boolean} True if the current breakpoint is desktop, false otherwise
 */
function isDesktopBreakpoint() {
  return mediaQueryLarge.matches;
}

/**
 * Check if the device is a touch device independently ot the screen size
 * @returns {boolean} True if the device is a touch device, false otherwise
 */
function isTouchDevice() {
  return 'ontouchstart' in window && navigator.maxTouchPoints > 0;
}

/**
 * Clamps a number between a minimum and maximum value.
 * @param {number} value - The input number to clamp.
 * @param {number} min - The minimum value.
 * @param {number} max - The maximum value.
 * @returns {number} The clamped value.
 */
function clamp(value, min, max) {
  return Math.max(min, Math.min(value, max));
}

/**
 * Calculates the center point of an element along the specified axis.
 * @param {Element} element - The DOM element to find the center of.
 * @param {'x' | 'y'} [axis] - The axis ('x' or 'y') to get the center for. If not provided, returns both axes.
 * @template {('x' | 'y')} T
 * @param {T} [axis]
 * @returns {T extends ('x' | 'y') ? number : {x: number, y: number}} The center point along the axis or an object with x and y coordinates.
 */
function center(element, axis) {
  const {
    left,
    width,
    top,
    height
  } = element.getBoundingClientRect();
  const point = {
    x: left + width / 2,
    y: top + height / 2
  };
  if (axis) return /**  @type {any} */point[axis];
  return /**  @type {any} */point;
}

/**
 * Calculates the start point of an element along the specified axis.
 * @param {Element} element - The DOM element to find the start of.
 * @param {'x' | 'y'} [axis] - The axis ('x' or 'y') to get the start for. If not provided, returns both axes.
 * @returns {number | {x: number, y: number}} The start point along the axis or an object with x and y coordinates.
 */
function start(element, axis) {
  const {
    left,
    top
  } = element.getBoundingClientRect();
  const point = {
    x: left,
    y: top
  };
  if (axis) return /**  @type {any} */point[axis];
  return /**  @type {any} */point;
}

/**
 * Finds the value in an array that is closest to a target value.
 * @param {number[]} values - An array of numbers.
 * @param {number} target - The target number to find the closest value to.
 * @returns {number} The value from the array closest to the target.
 */
function closest(values, target) {
  return values.reduce(function (prev, curr) {
    return Math.abs(curr - target) < Math.abs(prev - target) ? curr : prev;
  });
}

/**
 * Prevents the default action of an event.
 * @param {Event} event - The event to prevent the default action of.
 */
function preventDefault(event) {
  event.preventDefault();
}

/**
 * Get the visible elements within a root element.
 * @template {Element} T
 * @param {Element} root - The element within which elements should be visible.
 * @param {T[] | undefined} elements - The elements to check for visibility.
 * @param {number} [ratio=1] - The minimum percentage of the element that must be visible.
 * @param {'x' | 'y'} [axis] - Whether to only check along 'x' axis, 'y' axis, or both if undefined.
 * @returns {T[]} An array containing the visible elements.
 */
function getVisibleElements(root, elements, ratio = 1, axis) {
  if (!elements?.length) return [];
  const rootRect = root.getBoundingClientRect();
  return elements.filter(element => {
    const {
      width,
      height,
      top,
      right,
      left,
      bottom
    } = element.getBoundingClientRect();
    if (ratio < 1) {
      const intersectionLeft = Math.max(rootRect.left, left);
      const intersectionRight = Math.min(rootRect.right, right);
      const intersectionWidth = Math.max(0, intersectionRight - intersectionLeft);
      if (axis === 'x') {
        return width > 0 && intersectionWidth / width >= ratio;
      }
      const intersectionTop = Math.max(rootRect.top, top);
      const intersectionBottom = Math.min(rootRect.bottom, bottom);
      const intersectionHeight = Math.max(0, intersectionBottom - intersectionTop);
      if (axis === 'y') {
        return height > 0 && intersectionHeight / height >= ratio;
      }
      const intersectionArea = intersectionWidth * intersectionHeight;
      const elementArea = width * height;

      // Check that at least the specified ratio of the element is visible
      return elementArea > 0 && intersectionArea / elementArea >= ratio;
    }
    const isWithinX = left >= rootRect.left && right <= rootRect.right;
    if (axis === 'x') {
      return isWithinX;
    }
    const isWithinY = top >= rootRect.top && bottom <= rootRect.bottom;
    if (axis === 'y') {
      return isWithinY;
    }
    return isWithinX && isWithinY;
  });
}
function getIOSVersion() {
  const {
    userAgent
  } = navigator;
  const isIOS = /(iPhone|iPad)/i.test(userAgent);
  if (!isIOS) return null;
  const version = userAgent.match(/OS ([\d_]+)/)?.[1];
  const [major, minor] = version?.split('_') || [];
  if (!version || !major) return null;
  return {
    fullString: version.replace('_', '.'),
    major: parseInt(major, 10),
    minor: minor ? parseInt(minor, 10) : 0
  };
}

/**
 * Determines which grid items should be animated during a transition.
 * It makes an estimation based on the zoom-out card size because it's
 * the common denominator for both transition states. I.e. transitioning either
 * from 10 to 20 cards the other way around, both need 20 cards to be animated.
 * @param {Element} grid - The grid element
 * @param {Element[]} cards - The cards to animate
 * @returns {number} - Number of cards that should be animated
 */
function getCardsToAnimate(grid, cards) {
  if (!grid || !cards || cards.length === 0) return 0;
  const itemSample = cards[0];
  if (!itemSample) return 0;

  // Calculate the visible area of the grid for the Y axis. Assume X is always fully visible:
  const gridRect = grid.getBoundingClientRect();
  const visibleArea = {
    top: Math.max(0, gridRect.top),
    bottom: Math.min(window.innerHeight, gridRect.bottom)
  };
  const visibleHeight = Math.round(visibleArea.bottom - visibleArea.top);
  if (visibleHeight <= 0) return 0;

  /** @type {import('product-card').ProductCard | null} */
  const cardSample = itemSample.querySelector('product-card');
  const gridStyle = getComputedStyle(grid);
  const galleryAspectRatio = cardSample?.refs?.cardGallery?.style.getPropertyValue('--gallery-aspect-ratio') || '';
  let aspectRatio = parseFloat(galleryAspectRatio) || 0.5;
  if (galleryAspectRatio?.includes('/')) {
    const [width = '1', height = '2'] = galleryAspectRatio.split('/');
    aspectRatio = parseInt(width, 10) / parseInt(height, 10);
  }
  const cardGap = parseInt(cardSample?.refs?.productCardLink?.style.getPropertyValue('--product-card-gap') || '') || 12;
  const gridGap = parseInt(gridStyle.getPropertyValue('--product-grid-gap')) || 12;

  // Assume only a couple of lines of text in the card details (title and price).
  // If the title wraps into more lines, we might just animate more cards, but that's fine.
  const detailsSize = ((parseInt(gridStyle.fontSize) || 16) + 2) * 2;
  const isMobile = window.innerWidth < 750;

  // Always use the zoom-out state card width
  const cardWidth = isMobile ? Math.round((gridRect.width - gridGap) / 2) : 100;
  const cardHeight = Math.round(cardWidth / aspectRatio) + cardGap + detailsSize;

  // Calculate the number of cards that fit in the visible area:
  // - The width estimation is pretty accurate, we can ignore decimals.
  // - The height estimation needs to account for peeking rows, so we round up.
  const columnsInGrid = isMobile ? 2 : Math.floor((gridRect.width + gridGap) / (cardWidth + gridGap));
  const rowsInGrid = Math.ceil((visibleHeight - gridGap) / (cardHeight + gridGap));
  return columnsInGrid * rowsInGrid;
}

/**
 * Preloads an image
 * @param {string} src - The source of the image to preload
 */
function preloadImage(src) {
  const image = new Image();
  image.src = src;
}
class TextComponent extends HTMLElement {
  shimmer() {
    this.setAttribute('shimmer', '');
  }
}
if (!customElements.get('text-component')) {
  customElements.define('text-component', TextComponent);
}

/**
 * Resets the shimmer attribute on all elements in the container.
 * @param {Element} [container] - The container to reset the shimmer attribute on.
 */
function resetShimmer(container = document.body) {
  const shimmer = container.querySelectorAll('[shimmer]');
  shimmer.forEach(item => item.removeAttribute('shimmer'));
}

/**
 * Change the meta theme color of the browser.
 * @param {string} color - The color value (e.g., 'rgb(255, 255, 255)')
 */
function changeMetaThemeColor(color) {
  const metaThemeColor = document.head.querySelector('meta[name="theme-color"]');
  if (metaThemeColor && color) {
    metaThemeColor.setAttribute('content', color);
  }
}

/**
 * Gets the `view` URL search parameter value, if it exists.
 * Useful for Section Rendering API calls to get HTML markup for the correct template view.
 * Primarily used in testing alternative template views.
 * @returns {string | null} The view parameter value, or null if it doesn't exist
 */
function getViewParameterValue() {
  return new URLSearchParams(window.location.search).get('view');
}

/**
 * Helper to parse integer with a default fallback
 * Handles the case where 0 is a valid value (not falsy)
 * @template {number|null} T
 * @param {string|number|null|undefined} value - The value to parse
 * @param {T} defaultValue - The default value (number or null)
 * @returns {number|T} The parsed integer or default value
 */
function parseIntOrDefault(value, defaultValue) {
  if (value === null || value === undefined || value === '') {
    return defaultValue;
  }
  const parsed = parseInt(value.toString());
  return isNaN(parsed) ? defaultValue : parsed;
}
class Scheduler {
  /** @type {Set<() => void>} */
  #queue = new Set();
  /** @type {boolean} */
  #scheduled = false;

  /** @param {() => void} task */
  schedule = async task => {
    this.#queue.add(task);
    if (!this.#scheduled) {
      this.#scheduled = true;

      // Wait for any in-progress view transitions to finish
      if (viewTransition.current) await viewTransition.current;
      requestAnimationFrame(this.flush);
    }
  };
  flush = () => {
    for (const task of this.#queue) {
      setTimeout(task, 0);
    }
    this.#queue.clear();
    this.#scheduled = false;
  };
}
const scheduler = new Scheduler();

/**
 * Executes a callback once per session when in the Shopify theme editor
 * @param {HTMLElement} element - The element to check for the shopify editor block id
 * @param {string} sessionKeyName - Unique key for the session storage
 * @param {() => void} callback - Function to execute
 * @returns {void} - Void if the callback was executed, undefined if it wasn't
 */
function oncePerEditorSession(element, sessionKeyName, callback) {
  const isInThemeEditor = window.Shopify?.designMode;
  const shopifyEditorSectionId = JSON.parse(element.dataset.shopifyEditorSection || '{}').id;
  const shopifyEditorBlockId = JSON.parse(element.dataset.shopifyEditorBlock || '{}').id;
  const editorId = shopifyEditorSectionId || shopifyEditorBlockId;
  const uniqueSessionKey = `${sessionKeyName}-${editorId}`;
  if (isInThemeEditor && sessionStorage.getItem(uniqueSessionKey)) return;
  callback();
  if (isInThemeEditor) sessionStorage.setItem(uniqueSessionKey, 'true');
  return;
}

/**
 * A custom ResizeObserver that only calls the callback when the element is resized.
 * By default the ResizeObserver callback is called when the element is first observed.
 */
class ResizeNotifier extends ResizeObserver {
  #initialized = false;

  /**
  * @param {ResizeObserverCallback} callback
  */
  constructor(callback) {
    super(entries => {
      if (this.#initialized) return callback(entries, this);
      this.#initialized = true;
    });
  }
  disconnect() {
    this.#initialized = false;
    super.disconnect();
  }
}

/**
 * Sets the menuStyle dataset attribute on the header component element.
 * Only updates when the value actually changes to avoid layout shifts.
 */
function setHeaderMenuStyle() {
  const headerComponent = /** @type {HTMLElement} | null */document.querySelector('#header-component');
  if (!headerComponent) return;
  if (headerComponent.querySelector('.header__drawer--desktop')) {
    if (headerComponent.dataset.menuStyle !== 'drawer') {
      headerComponent.dataset.menuStyle = 'drawer';
    }
    return;
  }
  const overflowList = headerComponent.querySelector('overflow-list');
  const hasReachedMinimum = overflowList?.hasAttribute('minimum-reached') ?? false;
  const nextStyle = isTouchDevice() || hasReachedMinimum ? 'drawer' : 'menu';
  if (headerComponent.dataset.menuStyle !== nextStyle) {
    headerComponent.dataset.menuStyle = nextStyle;
  }
}

/**
 * Header group includes the header (with the menu, etc) and other sections like announcements, dividers, etc.
 * @param {HTMLElement | null} header - The header element
 * @param {HTMLElement | null} headerGroup - The header group element, defaults to the #header-group element
 * @returns {number} The height of the header group
 */
function calculateHeaderGroupHeight(header = document.querySelector('#header-component'), headerGroup = document.querySelector('#header-group')) {
  if (!headerGroup) return 0;
  let totalHeight = 0;
  const children = headerGroup.children;
  for (let i = 0; i < children.length; i++) {
    const element = children[i];
    if (element === header || !(element instanceof HTMLElement)) continue;
    totalHeight += element.offsetHeight;
  }

  // If the header is transparent and has a sibling section, add the height of the header to the total height
  if (header instanceof HTMLElement && header.hasAttribute('transparent') && header.parentElement?.nextElementSibling) {
    return totalHeight + header.offsetHeight;
  }
  return totalHeight;
}

/**
 * Updates CSS custom properties for transparent header offset calculation
 * Avoids expensive :has() selectors
 */
function updateTransparentHeaderOffset() {
  const header = document.querySelector('#header-component');
  const headerGroup = document.querySelector('#header-group');
  const hasHeaderSection = headerGroup?.querySelector('.header-section');
  if (!hasHeaderSection || !header?.hasAttribute('transparent')) {
    document.body.style.setProperty('--transparent-header-offset-boolean', '0');
    return;
  }
  const hasImmediateSection = hasHeaderSection.nextElementSibling?.classList.contains('shopify-section');
  const shouldApplyOffset = !hasImmediateSection ? '1' : '0';
  document.body.style.setProperty('--transparent-header-offset-boolean', shouldApplyOffset);
}

/**
 * Initialize and maintain header height CSS variables.
 */
function updateHeaderHeights() {
  const header = document.querySelector('header-component');

  // Early exit if no header - nothing to do
  if (!(header instanceof HTMLElement)) return;

  // Calculate initial heights
  const headerHeight = header.offsetHeight;
  const headerGroupHeight = calculateHeaderGroupHeight(header);
  const headerTopRow = /** @type {HTMLElement} | null */header.querySelector('.header__row--top');
  document.body.style.setProperty('--header-height', `${headerHeight}px`);
  document.body.style.setProperty('--header-group-height', `${headerGroupHeight}px`);
  if (headerTopRow) {
    header.style.setProperty('--top-row-height', `${headerTopRow.offsetHeight}px`);
  }
}
function updateAllHeaderCustomProperties() {
  updateHeaderHeights();
  updateTransparentHeaderOffset();
  setHeaderMenuStyle();
}

// Theme is not defined in some layouts, like the gift card page
if (typeof Theme !== 'undefined') {
  Theme.utilities = {
    ...Theme.utilities,
    scheduler: scheduler
  };
}

/***/ }),

/***/ 7695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: function() { return /* binding */ Scroller; },
/* harmony export */   R: function() { return /* binding */ scrollIntoView; }
/* harmony export */ });
/* harmony import */ var _theme_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6816);


/**
 * Timeout duration (in milliseconds) after which scroll is considered to have ended.
 * @constant {number}
 */
const SCROLL_END_TIMEOUT = 50;

/**
 * Class representing a Scroller that handles smooth scrolling and detects scroll end events.
 *
 * @class
 */
class Scroller {
  /**
  * The element to apply scrolling to.
  * @type {HTMLElement}
  */
  element;

  /**
  * Promise that resolves when scrolling ends.
  * @type {Promise<void>|undefined}
  */
  #promise = undefined;

  /**
  * Function to resolve the scroll end promise.
  * @type {Function|undefined}
  */
  #resolve = undefined;

  /**
  * Callback function to call while user is scrolling, throttled every 50ms.
  * @type {() => void}
  */
  #throttledCallback;

  /**
  * Callback function invoked after user scroll ends.
  * @type {() => void}
  */
  #endCallback;

  /**
  * Callback function invoked when scrolling starts, regardless of whether it was triggered by a user event.
  * @type {(() => void) | undefined}
  */
  #onScrollInit;

  /**
  * Callback function invoked when scrolling ends, regardless of whether it was triggered by a user event.
  * @type {(() => void) | undefined}
  */
  #onScrollEnd;

  /**
  * Whether the scroll was triggered by a user event.
  * @type {boolean}
  */
  #userEvent = true;

  /**
  * Whether the next scroll event should be ignored.
  * @type {boolean}
  */
  #ignore = false;

  /**
  * Whether the element is currently scrolling.
  * @type {boolean}
  */
  #isScrolling = false;

  /**
  * Creates a Scroller instance.
  *
  * @param {HTMLElement} element - The element to apply scrolling to.
  * @param {Object} options - The options for the scroller.
  * @param {() => void} options.onScroll - Function to call while scrolling and after scrolling ends.
  * @param {() => void} [options.onScrollStart] - Function to call when scrolling starts.
  * @param {() => void} [options.onScrollEnd] - Function to call after scrolling ends.
  */
  constructor(element, options) {
    this.#throttledCallback = (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_0__/* .throttle */ .nF)(options.onScroll, SCROLL_END_TIMEOUT);
    this.#endCallback = options.onScroll;
    this.#onScrollInit = options.onScrollStart;
    this.#onScrollEnd = options.onScrollEnd;
    this.element = element;
    this.element.addEventListener('scroll', this.#handleScroll);
  }

  /**
  * Scrolls to a specific position or element.
  * @param {number | HTMLElement} input - The position in pixels or an element to scroll to.
  * @param {Object} [options] - Options for the scroll.
  * @param {boolean} [options.instant] - Whether to scroll instantly.
  */
  async to(input, options) {
    let value;
    if (input instanceof HTMLElement) {
      const paddingStart = calculatePaddingStart(this.element, this.axis);
      value = input[`offset${this.#edge}`] - paddingStart;
    } else {
      value = input;
    }
    const currentPosition = this.element[`scroll${this.#edge}`];
    const willChange = currentPosition !== value;
    if (willChange) {
      this.#scroll({
        ...options,
        method: 'scrollTo',
        value
      });
    } else if (this.#isScrolling) {
      // If the scroll has started but then it's released in the same original position,
      // the scroll event will not fire, so we need to manually trigger the scroll end.
      this.#handleScrollEnd(false);
    }
  }

  /**
  * Scrolls by a certain number of pixels.
  * @param {number} value - The number of pixels to scroll by.
  * @param {Object} [options] - Options for the scroll.
  * @param {boolean} [options.instant] - Whether to scroll instantly.
  */
  by(value, options) {
    this.#scroll({
      ...options,
      method: 'scrollBy',
      value
    });
  }

  /**
  * Scrolls the element.
  * @param {Object} options - The options for the scroll.
  * @param {'scrollTo' | 'scrollBy'} options.method - The method to use to scroll.
  * @param {number} options.value - The value to scroll to.
  * @param {boolean} [options.instant] - Whether to scroll instantly.
  */
  #scroll(options) {
    const {
      method,
      value,
      instant = (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_0__/* .prefersReducedMotion */ .Oe)()
    } = options;
    this.#reset();
    this.#ignore = instant;
    this.#userEvent = false;

    // Check if we need to scroll at all
    const currentPosition = this.element[`scroll${this.#edge}`];
    const targetPosition = method === 'scrollBy' ? currentPosition + value : value;
    const scrollDistance = Math.abs(targetPosition - currentPosition);

    // If the distance is negligible, don't scroll and resolve immediately
    if (scrollDistance < 1) {
      return Promise.resolve();
    }
    if (!instant) this.#setup();
    this.element[method]({
      [this.#edge.toLowerCase()]: value,
      behavior: instant ? 'instant' : 'smooth'
    });
  }

  /**
  * Gets the scrolling axis ('x' or 'y') based on the element's dimensions.
  * @type {'x' | 'y'}
  * @readonly
  */
  get axis() {
    return getScrollAxis(this.element);
  }

  /**
  * Promise that resolves when scrolling ends.
  * @type {Promise<void>}
  * @readonly
  */
  get finished() {
    return this.#promise ?? Promise.resolve();
  }

  /**
  * Gets the scroll edge property ('Left' or 'Top') based on the axis.
  * @returns {'Left' | 'Top'}
  */
  get #edge() {
    return this.axis === 'x' ? 'Left' : 'Top';
  }

  /**
  * Sets up the scroll end promise if not already set.
  */
  #setup() {
    if (this.#promise) {
      return;
    }
    this.#promise = new Promise(resolve => this.#resolve = resolve);
  }
  #reset = () => {
    this.#handleScrollEnd.cancel();
    this.#resolve?.();
    this.#promise = undefined;
    this.#resolve = undefined;
    this.#userEvent = true;
    this.#ignore = false;
  };

  /**
  * Event handler for the 'scroll' event.
  */
  #handleScroll = () => {
    if (!this.#isScrolling) {
      this.#onScrollInit?.();
      this.#isScrolling = true;
    }
    if (this.#ignore) {
      this.#reset();
      this.#handleScrollEnd(false);
      return;
    }
    const userEvent = this.#userEvent;
    this.#setup();
    if (userEvent) this.#throttledCallback();
    this.#handleScrollEnd(userEvent);
  };

  /**
  * Handler called when scrolling has ended.
  */
  #handleScrollEnd = (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_0__/* .debounce */ .sg)(
  /**
  * @param {boolean} userEvent
  */
  userEvent => {
    this.#resolve?.();
    if (userEvent) this.#endCallback();
    this.#reset();
    if (this.#isScrolling) {
      this.#onScrollEnd?.();
      this.#isScrolling = false;
    }
  }, SCROLL_END_TIMEOUT);

  /**
  * Sets the scroll snap behavior of the element.
  * @param {boolean} value - Whether to enable scroll snap.
  */
  set snap(value) {
    // Changing the snap behavior will trigger a scroll event, which we should ignore
    this.#ignore = true;
    this.element.style.setProperty('scroll-snap-type', value ? `${this.axis} mandatory` : 'none');
  }

  /**
  * Destroys the Scroller instance.
  */
  destroy() {
    this.element.removeEventListener('scroll', this.#handleScroll);
  }
}

/**
 * Gets the scroll axis ('x' or 'y') based on the element's dimensions.
 * @param {HTMLElement} el - The element to get the scroll axis of.
 * @returns {'x' | 'y'}
 */
function getScrollAxis(el) {
  if (el.scrollHeight > el.clientHeight && el.scrollWidth === el.clientWidth) {
    return 'y';
  }
  if (el.scrollWidth > el.clientWidth && el.scrollHeight === el.clientHeight) {
    return 'x';
  }
  return el.scrollWidth > el.scrollHeight ? 'x' : 'y';
}

/**
 * Calculates the padding-start around an element to update the scroll offset.
 * @param {HTMLElement} element - The element to calculate the padding-start of.
 * @param {'x' | 'y'} axis - The axis to calculate the padding-start of.
 * @returns {number} The padding-start in pixels.
 */
function calculatePaddingStart(element, axis) {
  const computedStyle = getComputedStyle(element);
  const value = axis === 'x' ? computedStyle.paddingInlineStart : computedStyle.paddingBlockStart;
  return parseFloat(value);
}

/**
 * Scrolls an element into view.
 * @param {Element} element - The element to scroll into view.
 * @param {Object} options - The options for the scroll.
 * @param {ScrollBehavior} [options.behavior='smooth'] - The behavior of the scroll.
 * @param {'start' | 'center' | 'end'} [options.block='start'] - The block alignment of the element.
 * @param {'start' | 'center' | 'end'} [options.inline='start'] - The inline alignment of the element.
 * @param {Element} [options.ancestor] - The ancestor element to scroll into view.
 */
function scrollIntoView(element, {
  ancestor,
  behavior = 'smooth',
  block = 'start',
  inline = 'start'
} = {}) {
  if (!ancestor) {
    return element.scrollIntoView({
      behavior,
      block,
      inline
    });
  }
  const elemRect = element.getBoundingClientRect();
  const ancestorRect = ancestor.getBoundingClientRect();

  /**
  * Calculates the scroll offset for an element.
  * @param {'start' | 'center' | 'end'} alignment - The alignment of the element.
  * @param {number} ancestorStart - The start of the ancestor element.
  * @param {number} ancestorLength - The length of the ancestor element.
  * @param {number} elemStart - The start of the element.
  * @param {number} elemLength - The length of the element.
  * @param {number} currentScroll - The current scroll position.
  * @returns {number} The scroll offset.
  */
  const calculateScrollOffset = (alignment, ancestorStart, ancestorLength, elemStart, elemLength, currentScroll) => {
    switch (alignment) {
      case 'start':
        return currentScroll + elemStart - ancestorStart;
      case 'center':
        return currentScroll + elemStart - ancestorStart - ancestorLength / 2 + elemLength / 2;
      case 'end':
        return currentScroll + elemStart - ancestorStart - ancestorLength + elemLength;
      default:
        return currentScroll;
    }
  };
  const scrollTop = ancestor.scrollHeight > ancestor.clientHeight ? calculateScrollOffset(block, ancestorRect.top, ancestor.clientHeight, elemRect.top, elemRect.height, ancestor.scrollTop) : ancestor.scrollTop;
  const scrollLeft = ancestor.scrollWidth > ancestor.clientWidth ? calculateScrollOffset(inline, ancestorRect.left, ancestor.clientWidth, elemRect.left, elemRect.width, ancestor.scrollLeft) : ancestor.scrollLeft;
  ancestor.scrollTo({
    top: scrollTop,
    left: scrollLeft,
    behavior
  });
}

// Still extends HTMLElement over Component so that refs are still available to parent components (e.g. Slideshow)
class ScrollHint extends HTMLElement {
  /** @type {number | null} */
  #rafId = null;
  connectedCallback() {
    this.addEventListener('scroll', this.#handleScroll);
    this.#resizeObserver.observe(this);
  }
  disconnectedCallback() {
    this.removeEventListener('scroll', this.#handleScroll);
    this.#resizeObserver.disconnect();
    if (this.#rafId !== null) {
      cancelAnimationFrame(this.#rafId);
      this.#rafId = null;
    }
  }
  #handleScroll = () => {
    // Throttle scroll updates with requestAnimationFrame to avoid layout thrashing
    if (this.#rafId !== null) return;
    this.#rafId = requestAnimationFrame(() => {
      this.#rafId = null;
      this.#update();
    });
  };
  #update = () => {
    const {
      scrollTop,
      scrollHeight,
      clientHeight,
      scrollLeft,
      scrollWidth,
      clientWidth
    } = this;
    const scrollDirection = scrollWidth > clientWidth ? 'horizontal' : 'vertical';
    const scrollPercentage = scrollDirection === 'vertical' ? scrollTop / (scrollHeight - clientHeight) : scrollLeft / (scrollWidth - clientWidth);
    this.style.maskImage = Number.isNaN(scrollPercentage) ? '' : `linear-gradient(
        to ${scrollDirection === 'vertical' ? 'bottom' : 'right'},
        transparent ${scrollPercentage > 0 ? 1 : 0}%,
        black ${scrollPercentage < 0.1 ? scrollPercentage * 100 : 10}%,
        black ${scrollPercentage > 0.9 ? scrollPercentage * 100 : 90}%,
        transparent 100%
      )`;
  };
  #resizeObserver = new ResizeObserver(this.#update);
}
if (!customElements.get('scroll-hint')) {
  customElements.define('scroll-hint', ScrollHint);
}

/***/ })

/******/ });
/************************************************************************/
/******/ // The module cache
/******/ var __webpack_module_cache__ = {};
/******/ 
/******/ // The require function
/******/ function __webpack_require__(moduleId) {
/******/ 	// Check if module is in cache
/******/ 	var cachedModule = __webpack_module_cache__[moduleId];
/******/ 	if (cachedModule !== undefined) {
/******/ 		return cachedModule.exports;
/******/ 	}
/******/ 	// Create a new module (and put it into the cache)
/******/ 	var module = __webpack_module_cache__[moduleId] = {
/******/ 		// no module.id needed
/******/ 		// no module.loaded needed
/******/ 		exports: {}
/******/ 	};
/******/ 
/******/ 	// Execute the module function
/******/ 	__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 
/******/ 	// Return the exports of the module
/******/ 	return module.exports;
/******/ }
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ !function() {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = function(exports, definition) {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ }();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ !function() {
/******/ 	__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ }();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   b: function() { return /* binding */ Slideshow; }
/* harmony export */ });
/* harmony import */ var _theme_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2443);
/* harmony import */ var _theme_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6816);
/* harmony import */ var _theme_scrolling__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7695);
/* harmony import */ var _theme_events__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2375);





// The threshold for determining visibility of slides.
const SLIDE_VISIBLITY_THRESHOLD = 0.7;

/**
 * Shared viewport observer manager for lazy scroll enablement.
 *
 * Limit the number of compositor layers created by slideshows by only enabling scrolling when the slideshow is in the viewport.
 * Resolves known issues with iOS Safari where too many composition layers will crash the page.
 * When a slideshow is NOT in the viewport, it has overflow: hidden (no compositor layer).
 * When a slideshow enters the viewport, the [in-viewport] attribute is added, enabling scrolling.
 */
class SlideshowViewportObserver {
  /** @type {SlideshowViewportObserver | null} */
  static #instance = null;

  /** @type {IntersectionObserver | null} */
  #observer = null;

  /** @type {Set<Slideshow>} */
  #pendingHydrations = new Set();

  /**
   * Hydrates deferred slides in a single idle callback for all slideshows entering the viewport,
   * so their setup shares one style/layout pass instead of one per product card.
   * @param {Slideshow} slideshow
   */
  #queueHydration(slideshow) {
    if (!this.#pendingHydrations.size) {
      (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .requestIdleCallback */ .BB)(() => {
        const slideshows = [...this.#pendingHydrations];
        this.#pendingHydrations.clear();
        for (const pending of slideshows) pending.hydrateDeferredSlides();
      });
    }
    this.#pendingHydrations.add(slideshow);
  }

  /**
  * Gets the singleton instance
  * @returns {SlideshowViewportObserver}
  */
  static getInstance() {
    if (!this.#instance) {
      this.#instance = new SlideshowViewportObserver();
    }
    return this.#instance;
  }

  /**
  * Registers a slideshow to be observed for viewport visibility
  * @param {Slideshow} slideshow - The slideshow to observe
  */
  observe(slideshow) {
    if (!this.#observer) {
      this.#observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          const slideshowElement = /** @type {Slideshow} */entry.target;
          if (entry.isIntersecting) {
            slideshowElement.setAttribute('in-viewport', '');
            this.#queueHydration(slideshowElement);
            // Images skipped while off-screen (see #ensureSlideImagesLoad) are loaded now,
            // including the nested product card galleries of a carousel.
            slideshowElement.refreshCurrentSlideImages();
            for (const nested of slideshowElement.querySelectorAll('slideshow-component')) {
              /** @type {Slideshow} */nested.refreshCurrentSlideImages?.();
            }
          } else {
            slideshowElement.removeAttribute('in-viewport');
          }
        }
      }, {
        rootMargin: '100px'
      });
    }
    this.#observer.observe(slideshow);
  }

  /**
  * Unregisters a slideshow from viewport observation
  * @param {Slideshow} slideshow - The slideshow to unobserve
  */
  unobserve(slideshow) {
    this.#observer?.unobserve(slideshow);
    slideshow.removeAttribute('in-viewport');
  }
}

/**
 * Slideshow custom element that allows sliding between content.
 *
 * @typedef {Object} Refs
 * @property {HTMLElement} scroller
 * @property {HTMLElement} slideshowContainer
 * @property {HTMLElement[]} [slides]
 * @property {HTMLElement} [current]
 * @property {HTMLElement[]} [thumbnails]
 * @property {HTMLElement[]} [dots]
 * @property {HTMLButtonElement} [previous]
 * @property {HTMLButtonElement} [next]
 * @property {HTMLButtonElement} [autoplayToggle]
 * @property {HTMLElement} [slideshowControls]
 *
 * @extends {Component<Refs>}
 */
class Slideshow extends _theme_component__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .u {
  static get observedAttributes() {
    return ['initial-slide'];
  }

  /**
  * @param {string} name
  * @param {string} oldValue
  * @param {string} newValue
  */
  attributeChangedCallback(name, oldValue, newValue) {
    // Collection page filtering will Morph slideshow galleries in place, updating
    // the slideshow[initial-slide] and slideshow-slide[hidden] attributes.
    // We need to re-select() the slide after the morph is complete, but not before
    // slideshow-slide elements have their [hidden] attribute updated.
    if (name === 'initial-slide' && oldValue !== newValue) {
      queueMicrotask(() => {
        // Only select if the component is connected and initialized
        if (!this.isConnected || !this.#scroll || !this.refs.slides) return;
        const index = parseInt(newValue, 10) || 0;
        const slide_id = this.refs.slides[index]?.getAttribute('slide-id');
        if (slide_id) {
          this.select({
            id: slide_id
          }, undefined, {
            animate: false
          });
        }
      });
    }
  }
  requiredRefs = ['scroller'];
  async connectedCallback() {
    super.connectedCallback();

    // Register with shared viewport observer for lazy scroll enablement.
    // This prevents iOS Safari crashes caused by too many compositor layers.
    SlideshowViewportObserver.getInstance().observe(this);

    // Deferred slides are also hydrated on interaction, before the viewport observer kicks in
    // (or again after a morph re-renders the <template>).
    this.addEventListener('pointerenter', this.#handleHydrationIntent);
    this.addEventListener('focusin', this.#handleHydrationIntent);
    this.addEventListener('touchstart', this.#handleHydrationIntent, {
      passive: true
    });

    // Nested slideshows (product card carousels inside a parent carousel) need
    // content-visibility: visible immediately so their slides render without
    // waiting for a hover to set the [actioned] attribute.
    if (this.hasAttribute('data-allow-nested')) {
      this.setAttribute('actioned', '');
    }

    // Wait for any in-progress view transitions to finish
    if (_theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .viewTransition */ .B5.current) {
      await _theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .viewTransition */ .B5.current;
      // It's possible that the slideshow was disconnected before the view transition finished
      if (!this.isConnected) return;
    }
    this.#connected = true;
    const slideCount = this.slides?.length || 0;
    slideCount <= 1 ? this.#setupSlideshowWithoutControls() : this.#setupSlideshow();
    this.#syncNestedPassthrough();
  }
  disconnectedCallback() {
    super.disconnectedCallback();

    // Unregister from shared viewport observer
    SlideshowViewportObserver.getInstance().unobserve(this);
    this.#connected = false;
    this.removeEventListener('pointerenter', this.#handleHydrationIntent);
    this.removeEventListener('focusin', this.#handleHydrationIntent);
    this.removeEventListener('touchstart', this.#handleHydrationIntent);
    if (this.#scroll) {
      const {
        scroller
      } = this.refs;
      scroller.removeEventListener('pointerdown', this.#handlePointerDown);
      this.#scroll.destroy();
    }
    const slideCount = this.slides?.length || 0;
    if (slideCount > 1) {
      this.removeEventListener('mouseenter', this.suspend);
      this.removeEventListener('mouseleave', this.resume);
      this.removeEventListener('focusin', this.#handleFocusIn);
      this.removeEventListener('pointerenter', this.#handlePointerEnter);
      document.removeEventListener('visibilitychange', this.#handleVisibilityChange);
    }
    if (this.#resizeObserver) {
      this.#resizeObserver.disconnect();
    }
    if (this.#intersectionObserver) {
      this.#intersectionObserver.disconnect();
      this.#intersectionObserver = null;
    }
    this.#teardownParentDialogAutoplayGuard();
  }

  /**
   * Product card galleries only render their first slide; the others wait in a
   * <template data-deferred-slides> inside the scroller (no DOM nodes, no image requests).
   * Moves them into the scroller and sets up the full slideshow. No-op without a template.
   */
  hydrateDeferredSlides() {
    const template = this.refs.scroller?.querySelector(':scope > template[data-deferred-slides]');
    if (!(template instanceof HTMLTemplateElement)) return;
    const deferredSlides = [...template.content.children];
    template.replaceWith(template.content);
    // Sync refs.slides now rather than on the next MutationObserver tick
    this.updatedCallback();

    // Keep the inline aspect ratio set on the rendered slides (paginated-list-aspect-ratio.js)
    const aspectRatio = this.refs.slides?.[0]?.style.aspectRatio;
    if (aspectRatio) {
      for (const slide of deferredSlides) {
        if (slide instanceof HTMLElement) slide.style.aspectRatio = aspectRatio;
      }
    }

    // connectedCallback hasn't run its setup yet (pending view transition): it will see the new slides
    if (!this.#connected) return;
    if (this.#scroll) {
      // Already set up (template re-rendered by a morph): only track the new slides
      this.#setupIntersectionObserver();
      this.#updateControlsVisibility();
    } else if ((this.slides?.length || 0) > 1) {
      this.#setupSlideshow();
    }
    this.#syncNestedPassthrough();
  }
  #handleHydrationIntent = () => this.hydrateDeferredSlides();

  /** Whether connectedCallback has run its slideshow setup. */
  #connected = false;

  /** Indicates whether the slideshow is nested inside another slideshow. */
  get isNested() {
    return this.parentElement?.closest('slideshow-component') !== null;
  }

  /**
   * Nested product-card galleries must not capture swipe/drag — the parent
   * product carousel should scroll instead. Arrows still change images.
   */
  #syncNestedPassthrough = () => {
    const passthrough = this.isNested && this.hasAttribute('data-allow-nested');
    this.toggleAttribute('mobile-disabled', passthrough);
    this.classList.toggle('slideshow--nested-passthrough', passthrough);
    if (passthrough) {
      this.#keepNestedCurrentSlideVisible();
    }
  };

  /**
   * iOS Safari can skip fetching images that started as loading=lazy inside
   * overflow/content-visibility containers. Drop lazy and retrigger src once.
   * @param {ParentNode | null | undefined} root
   */
  #ensureSlideImagesLoad(root) {
    if (!root) return;
    // Off-screen, forcing eager would fetch every card of every carousel (hidden tab panels
    // included) on page load. Retried by SlideshowViewportObserver once near the viewport.
    if (!this.#isNearViewport()) return;
    const images = root.querySelectorAll('img');
    for (const img of images) {
      if (img.complete && img.naturalWidth > 0) continue;
      if (img.dataset.iosReload === 'true') continue;
      img.dataset.iosReload = 'true';
      if (img.getAttribute('loading') === 'lazy') {
        // `sizes="auto"` is only valid on lazy images: once eager, the browser falls back
        // to the viewport width and picks a huge candidate (up to 3840w for a card).
        const sizes = img.getAttribute('sizes');
        if (sizes?.startsWith('auto')) {
          img.sizes = sizes.replace(/^auto\s*,?\s*/, '') || '100vw';
        }
        img.loading = 'eager';
      }
      const src = img.getAttribute('src');
      if (src && !img.complete) {
        img.src = src;
      }
    }
  }

  /**
   * Whether this slideshow, or the carousel it is nested in, is within 100px of the viewport.
   * The parent is checked too, as iOS can miss intersections of nested galleries.
   * @returns {boolean}
   */
  #isNearViewport() {
    if (this.hasAttribute('in-viewport')) return true;
    return this.parentElement?.closest('slideshow-component')?.hasAttribute('in-viewport') ?? false;
  }

  /** Loads the current slide images once the slideshow nears the viewport. */
  refreshCurrentSlideImages() {
    const {
      slides
    } = this;
    if (!slides?.length) return;
    this.#ensureSlideImagesLoad(slides[this.current] || slides[0]);
  }

  /**
   * iOS Safari reports no intersections for nested overflow:hidden galleries that
   * are only partially on-screen, which would otherwise inert every image slide.
   */
  #keepNestedCurrentSlideVisible() {
    const slides = this.slides;
    if (!slides?.length) return;
    const currentSlide = slides[this.current] || slides[0];
    currentSlide?.removeAttribute('inert');
    currentSlide?.setAttribute('aria-hidden', 'false');
    this.#ensureSlideImagesLoad(currentSlide);
  }
  get initialSlide() {
    return this.refs.slides?.[this.initialSlideIndex];
  }

  /**
  * Selects a slide based on the input index.
  * @param {number|string|{id: string}} input - The index or id of the slide to select.
  * @param {Event} [event] - The event that triggered the selection.
  * @param {Object} [options] - The options for the selection.
  * @param {boolean} [options.animate=true] - Whether to animate the selection.
  */
  async select(input, event, options = {}) {
    if (this.#disabled || !this.refs.slides?.length) return;
    if (!this.#scroll) return;

    // Store the actual current slide before any mutations
    const currentSlide = this.slides?.[this.current];
    for (const slide of this.refs.slides) {
      if (slide.hasAttribute('reveal')) {
        slide.removeAttribute('reveal');
        slide.setAttribute('inert', '');
      }
    }

    // Figure out the raw desired index (could be -1 if user is on first slide and clicks prev)
    let requestedIndex = (() => {
      if (typeof input === 'number') return input;
      if (typeof input === 'string') return parseInt(input, 10);
      if ('id' in input) {
        const requestedSlide = this.refs.slides.find(slide => slide.getAttribute('slide-id') == input.id);
        if (!requestedSlide || !this.slides) return;

        // Force the slide to be revealed if it is hidden
        if (requestedSlide.hasAttribute('hidden')) {
          requestedSlide.setAttribute('reveal', '');
          requestedSlide.removeAttribute('inert');
        }
        return this.slides.indexOf(requestedSlide);
      }
    })();
    const {
      current
    } = this;
    const {
      slides
    } = this;

    // Guard checks: no slides, invalid index, or selecting the same slide
    if (!slides?.length || requestedIndex === undefined || isNaN(requestedIndex)) return;
    const requestedSlideElement = slides?.[requestedIndex];
    if (currentSlide === requestedSlideElement) return;
    if (!this.infinite) requestedIndex = (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .clamp */ .qE)(requestedIndex, 0, slides.length - 1);
    event?.preventDefault();
    const {
      animate = true
    } = options;
    const lastIndex = slides.length - 1;

    // Decide the actual target index (clamp for infinite loop)
    let index = requestedIndex;
    if (requestedIndex < 0) index = lastIndex;else if (requestedIndex > lastIndex) index = 0;
    const isAdjacentSlide = Math.abs(index - current) <= 1 && requestedIndex >= 0 && requestedIndex <= lastIndex;
    const {
      visibleSlides
    } = this;
    const instant = (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .prefersReducedMotion */ .Oe)() || !animate;

    // If jump is more than 1 or we looped, do the placeholder + reorder trick
    if (!instant && !isAdjacentSlide && visibleSlides.length === 1) {
      this.#disabled = true;
      await this.#scroll.finished; // ensure we're not mid-scroll

      const targetSlide = slides[index];
      if (!targetSlide || !currentSlide) return;

      // Create a placeholder in the original DOM position of targetSlide
      const placeholder = document.createElement('slideshow-slide');
      targetSlide.before(placeholder);

      // Decide whether targetSlide goes before or after currentSlide
      // so that we scroll a short distance in the correct direction
      if (requestedIndex < current) {
        currentSlide.before(targetSlide);
      } else {
        currentSlide.after(targetSlide);
      }
      if (current === 0) this.#scroll.to(currentSlide, {
        instant: true
      });

      // Once that scroll finishes, restore the DOM
      queueMicrotask(async () => {
        await this.#scroll.finished;
        this.#disabled = false;

        // Restore the slide back to its original position. This triggers a scroll event.
        placeholder.replaceWith(targetSlide);

        // Instantly scroll to the target slide as its position will have changed
        this.#scroll.to(targetSlide, {
          instant: true
        });

        // External video iframes can shift layout right after wrap restore.
        // Re-align one frame later to avoid showing a sliver of the adjacent slide.
        if (targetSlide.querySelector('iframe')) {
          requestAnimationFrame(() => {
            this.#scroll.to(targetSlide, {
              instant: true
            });
          });
        }

        // Force Safari to recalculate the timeline state on timeline refresh (after loop)
        requestAnimationFrame(() => {
          this.setAttribute('refreshing-timeline', '');
          requestAnimationFrame(() => {
            this.removeAttribute('refreshing-timeline');
          });
        });
      });
    }
    const slide = slides[index];
    if (!slide) return;
    const previousIndex = this.current;
    slide.removeAttribute('inert');
    this.#ensureSlideImagesLoad(slide);
    if (this.#scroll) {
      this.#scroll.to(slide, {
        instant
      });
    }
    this.current = this.slides?.indexOf(slide) || 0;
    this.#centerSelectedThumbnail(index, instant ? 'instant' : 'smooth');
    this.dispatchEvent(new _theme_events__WEBPACK_IMPORTED_MODULE_3__/* .SlideshowSelectEvent */ .$b({
      index,
      previousIndex,
      userInitiated: event != null,
      trigger: 'select',
      slide,
      id: slide.getAttribute('slide-id')
    }));
  }

  /**
  * Advances to the next slide.
  * @param {Event} [event] - The event that triggered the next slide.
  * @param {Object} [options] - The options for the next slide.
  * @param {boolean} [options.animate=true] - Whether to animate the next slide.
  */
  next(event, options) {
    event?.preventDefault();
    event?.stopPropagation();
    return this.select(this.nextIndex, event, options);
  }

  /**
  * Goes back to the previous slide.
  * @param {Event} [event] - The event that triggered the previous slide.
  * @param {Object} [options] - The options for the previous slide.
  * @param {boolean} [options.animate=true] - Whether to animate the previous slide.
  */
  previous(event, options) {
    event?.preventDefault();
    event?.stopPropagation();
    return this.select(this.previousIndex, event, options);
  }

  /**
  * Starts automatic slide playback.
  * @param {number} [interval] - The time interval in seconds between slides.
  */
  play(interval = this.autoplayInterval) {
    if (this.#interval) return;
    this.paused = false;
    this.#resumeControlledMedia();
    this.#interval = setInterval(() => {
      if (this.pauseOnHover && this.matches(':hover') || document.hidden) return;
      this.next();
    }, interval);
  }

  /**
  * Pauses automatic slide playback.
  */
  pause() {
    this.paused = true;
    this.suspend();
    this.#pauseControlledMedia();
  }

  /**
  * Toggles automatic slide and media playback from a single control.
  */
  togglePlayback() {
    this.paused ? this.play() : this.pause();
  }
  get paused() {
    return this.hasAttribute('paused');
  }
  set paused(value) {
    if (value) {
      this.setAttribute('paused', '');
    } else {
      this.removeAttribute('paused');
    }
    const autoplayToggle = this.refs.autoplayToggle;
    if (autoplayToggle instanceof HTMLButtonElement) {
      const label = value ? autoplayToggle.dataset.playLabel : autoplayToggle.dataset.pauseLabel;
      if (label) autoplayToggle.setAttribute('aria-label', label);
    }
    if (this.autoplay) {
      this.setAttribute('aria-live', value ? 'polite' : 'off');
    }
  }

  /**
  * Suspends automatic slide playback.
  */
  suspend() {
    clearInterval(this.#interval);
    this.#interval = undefined;
  }

  /**
  * Resumes automatic slide playback if autoplay is enabled.
  */
  resume() {
    if (!this.autoplay) return;
    if (!this.#canAutoplayInCurrentContext()) {
      this.suspend();
      return;
    }
    if (this.paused && !this.hasAttribute('disable-hover-pause')) return;
    this.paused = false;
    this.suspend();
    this.play();
  }
  get autoplay() {
    return Boolean(this.autoplayInterval);
  }
  get pauseOnHover() {
    return !this.hasAttribute('disable-hover-pause');
  }
  get pauseOnFocus() {
    return this.hasAttribute('pause-on-focus');
  }
  get controlsMedia() {
    return this.hasAttribute('controls-media');
  }

  /**
  * Pauses media currently playing inside the slideshow and remembers which media can be resumed.
  */
  #pauseControlledMedia() {
    if (!this.controlsMedia) return;
    const currentSlide = this.slides?.[this.current];
    for (const media of this.querySelectorAll('deferred-media')) {
      const video = media.querySelector('video');
      const isPlaying = Reflect.get(media, 'isPlaying') === true || video instanceof HTMLVideoElement && !video.paused;
      const isCurrentAutoplay = media.hasAttribute('autoplay') && currentSlide?.contains(media);
      if (isPlaying || isCurrentAutoplay) {
        this.#mediaPausedByControl.add(media);
      }
      const pauseMedia = Reflect.get(media, 'pauseMedia');
      if (typeof pauseMedia === 'function') {
        pauseMedia.call(media);
      } else if (video instanceof HTMLVideoElement) {
        video.pause();
      }
    }
    for (const video of this.querySelectorAll('video')) {
      if (video.closest('deferred-media')) continue;
      if (!video.paused) {
        this.#mediaPausedByControl.add(video);
      }
      video.pause();
    }
  }

  /**
  * Resumes autoplay media, or media previously paused by the shared control, in the current slide only.
  */
  #resumeControlledMedia() {
    if (!this.controlsMedia) return;
    const currentSlide = this.slides?.[this.current];
    if (!currentSlide) return;
    for (const media of currentSlide.querySelectorAll('deferred-media')) {
      if (!media.hasAttribute('autoplay') && !this.#mediaPausedByControl.has(media)) continue;
      const playMedia = Reflect.get(media, 'playMedia');
      const video = media.querySelector('video');
      if (typeof playMedia === 'function') {
        playMedia.call(media);
      } else if (video instanceof HTMLVideoElement) {
        video.play();
      }
    }
    for (const video of currentSlide.querySelectorAll('video')) {
      if (video.closest('deferred-media')) continue;
      if (!video.autoplay && !this.#mediaPausedByControl.has(video)) continue;
      video.play();
    }
  }
  get autoplayInterval() {
    const interval = this.getAttribute('autoplay');
    const value = parseFloat(`${interval}`);
    if (Number.isNaN(value) || value <= 0) return undefined;
    return value * 1000;
  }
  get autoplayWhenParentDialogOpen() {
    return this.hasAttribute('autoplay-when-parent-dialog-open');
  }

  /**
  * The current slide index.
  * @type {number}
  */
  #current = 0;
  get current() {
    return this.#current;
  }

  /**
  * Sets the current slide index and update the DOM
  * @type {number}
  */
  set current(value) {
    const {
      current,
      thumbnails,
      dots,
      slides,
      previous,
      next
    } = this.refs;
    this.#current = value;
    if (current) current.textContent = `${value + 1}`;
    for (const controls of [thumbnails, dots]) {
      controls?.forEach((el, i) => el.setAttribute('aria-selected', `${i === value}`));
    }
    if (previous) previous.disabled = Boolean(!this.infinite && value === 0);
    if (next) next.disabled = Boolean(!this.infinite && slides && this.nextIndex >= slides.length);
    this.#applyActiveSlideControlsIconColor(value);
  }
  get infinite() {
    return this.getAttribute('infinite') != null;
  }
  get visibleSlides() {
    return this.#visibleSlides;
  }
  get previousIndex() {
    const {
      current,
      visibleSlides
    } = this;
    const modifier = visibleSlides.length > 1 ? visibleSlides.length : 1;
    return current - modifier;
  }
  get nextIndex() {
    const {
      current,
      visibleSlides
    } = this;
    const modifier = visibleSlides.length > 1 ? visibleSlides.length : 1;
    return current + modifier;
  }
  get atStart() {
    const {
      current,
      slides
    } = this;
    return slides?.length ? current === 0 : false;
  }
  get atEnd() {
    const {
      current,
      slides
    } = this;
    return slides?.length ? current === slides.length - 1 : false;
  }

  /**
  * Sets the disabled attribute.
  * @param {boolean} value - The value to set the disabled attribute to.
  */
  set disabled(value) {
    this.setAttribute('disabled', String(value));
  }
  /**
  * Whether the slideshow is disabled.
  * @type {boolean}
  */
  get disabled() {
    return this.getAttribute('disabled') === 'true' || this.hasAttribute('mobile-disabled') && !_theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueryLarge */ .GO.matches;
  }

  /**
  * Indicates whether the slideshow is temporarily disabled (e.g., during infinite loop transition).
  * @type {boolean}
  */
  #disabled = false;

  /**
  * The interval ID for automatic playback.
  * @type {number|undefined}
  */
  #interval = undefined;

  /**
  * Media elements paused by the shared slideshow control.
  * @type {Set<Element>}
  */
  #mediaPausedByControl = new Set();

  /**
  * The Scroller instance that manages scrolling.
  * @type {Scroller}
  */
  #scroll;

  /**
  * The ResizeObserver instance for monitoring scroller size changes
  * @type {ResizeObserver}
  */
  #resizeObserver;

  /**
  * IntersectionObserver for efficient visibility tracking of slides
  * @type {IntersectionObserver | null}
  */
  #intersectionObserver = null;

  /**
  * The closest parent dialog that controls autoplay context.
  * @type {HTMLDialogElement | null}
  */
  #parentDialog = null;

  /**
  * Observer for parent dialog `open` attribute changes.
  * @type {MutationObserver | null}
  */
  #parentDialogAutoplayObserver = null;

  /**
  * Cached visible slides result from IntersectionObserver
  * @type {HTMLElement[]}
  */
  #visibleSlides = [];

  /**
  * Slides that intersect the scroller (any visible portion).
  * @type {Set<HTMLElement>}
  */
  #intersectingSlides = new Set();

  /**
  * Setup the slideshow without controls for zero or one slides
  */
  #setupSlideshowWithoutControls() {
    this.current = 0;
    this.#updateControlsVisibility();
    if (this.refs.slides?.[0]) {
      this.refs.slides[0].removeAttribute('inert');
    }
  }

  /**
  * Setup the slideshow with controls for when there are multiple slides
  */
  #setupSlideshow() {
    // Setup IntersectionObserver first for efficient visibility tracking
    this.#setupIntersectionObserver();

    // Setup the scroll instance
    const {
      scroller
    } = this.refs;
    this.#scroll = new _theme_scrolling__WEBPACK_IMPORTED_MODULE_2__/* .Scroller */ .H(scroller, {
      onScroll: this.#handleScroll,
      onScrollStart: this.#onTransitionInit,
      onScrollEnd: this.#onTransitionEnd
    });
    scroller.addEventListener('pointerdown', this.#handlePointerDown);
    this.addEventListener('mouseenter', this.suspend);
    this.addEventListener('mouseleave', this.resume);
    if (this.pauseOnFocus) {
      this.addEventListener('focusin', this.#handleFocusIn);
    }
    this.addEventListener('pointerenter', this.#handlePointerEnter);
    document.addEventListener('visibilitychange', this.#handleVisibilityChange);
    this.#updateControlsVisibility();
    this.#setupParentDialogAutoplayGuard();
    this.disabled = this.isNested && !this.hasAttribute('data-allow-nested') || this.disabled;
    this.#syncNestedPassthrough();
    this.resume();
    this.current = this.initialSlideIndex;

    // Batch reads and writes to the DOM
    _theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .scheduler */ .ck.schedule(() => {
      let visibleSlidesAmount = 0;
      const initialSlideId = this.initialSlide?.getAttribute('slide-id');

      // Wait for next frame to ensure layout is fully calculated before setting initial scroll position
      // This prevents race conditions on Safari mobile when section_width is 'full-width'
      requestAnimationFrame(() => {
        if (this.initialSlideIndex !== 0 && initialSlideId) {
          this.select({
            id: initialSlideId
          }, undefined, {
            animate: false
          });
          visibleSlidesAmount = 1;
        } else {
          visibleSlidesAmount = this.#updateVisibleSlides();
          if (visibleSlidesAmount === 0) {
            this.select(0, undefined, {
              animate: false
            });
            visibleSlidesAmount = 1;
          }
        }
        this.#updateControlsVisibility();
      });
      this.#resizeObserver = new ResizeObserver(async () => {
        if (_theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .viewTransition */ .B5.current) await _theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .viewTransition */ .B5.current;
        if (visibleSlidesAmount > 1) {
          this.#updateVisibleSlides();
        }
        this.#updateControlsVisibility();
      });
      this.#resizeObserver.observe(this.refs.slideshowContainer);
    });
  }

  /**
  * Callback invoked on user initiated scroll to sync the current slide index
  * and emit a slide change event if the index has changed.
  */
  #handleScroll = () => {
    const previousIndex = this.#current;
    const index = this.#sync();
    if (index === previousIndex) return;
    const slide = this.slides?.[index];
    if (!slide) return;
    this.dispatchEvent(new _theme_events__WEBPACK_IMPORTED_MODULE_3__/* .SlideshowSelectEvent */ .$b({
      index,
      previousIndex,
      userInitiated: true,
      trigger: 'scroll',
      slide,
      id: slide.getAttribute('slide-id')
    }));
  };
  #onTransitionInit = () => {
    this.setAttribute('transitioning', '');
  };
  #onTransitionEnd = () => {
    this.#updateVisibleSlides();
    this.removeAttribute('transitioning');
  };

  /**
  * Synchronizes the scroll position and updates the current slide index.
  * @returns {number} The index of the current slide.
  */
  #sync = () => {
    const {
      slides
    } = this;
    if (!slides) return this.current = 0;
    if (!this.#scroll) return this.current = 0;
    const visibleSlides = this.visibleSlides;
    if (!visibleSlides.length) return this.current;
    const {
      axis
    } = this.#scroll;
    const {
      scroller
    } = this.refs;
    const centers = visibleSlides.map(slide => (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .center */ .gX)(slide, axis));
    const referencePoint = visibleSlides.length > 1 ? scroller.getBoundingClientRect()[axis] : (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .center */ .gX)(scroller, axis);
    const closestCenter = (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .closest */ .kp)(centers, referencePoint);
    const closestVisibleSlide = visibleSlides[centers.indexOf(closestCenter)];
    if (!closestVisibleSlide) return this.current = 0;
    const index = slides.indexOf(closestVisibleSlide);
    return this.current = index;
  };
  #dragging = false;

  /**
  * Handles the 'pointerdown' event to start dragging slides.
  * @param {PointerEvent} event - The pointerdown event.
  */
  #handlePointerDown = event => {
    const {
      slides
    } = this;
    if (!slides || slides.length <= 1) return;
    if (!(event.target instanceof Element)) return;
    if (this.disabled || this.#dragging) return;
    if (this.isNested && this.hasAttribute('data-allow-nested')) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    if (this.hasAttribute('native-drag-mobile') && !_theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueryLarge */ .GO.matches) return;

    // Check if the event target is within a 3D model interactive element
    // This prevents the slideshow from capturing drag events when interacting with 3D models
    if (event.target.closest('model-viewer')) {
      return;
    }
    event.preventDefault();
    // Store initial position but don't start handling yet
    const {
      axis
    } = this.#scroll;
    const startPosition = event[axis];
    const controller = new AbortController();
    const {
      signal
    } = controller;
    let previousTime = performance.now();
    let previous = startPosition;
    let velocity = 0;
    let moved = false;
    let distanceTravelled = 0;
    this.#dragging = true;

    /**
    * Handles the 'pointermove' event to update the scroll position.
    * @param {PointerEvent} event - The pointermove event.
    */
    const onPointerMove = event => {
      const current = event[axis];
      const initialDelta = startPosition - current;
      if (!initialDelta) return;
      if (!moved) {
        moved = true;
        this.setPointerCapture(event.pointerId);

        // Prevent clicks once the user starts dragging
        document.addEventListener('click', _theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .preventDefault */ .wo, {
          once: true,
          signal
        });
        const movingRight = initialDelta < 0;
        const movingLeft = initialDelta > 0;

        // Check if the current slideshow should handle this drag
        const closestSlideshow = this.parentElement?.closest('slideshow-component');
        const isNested = closestSlideshow instanceof Slideshow && closestSlideshow !== this;
        const cannotMoveInDirection = movingRight && this.atStart || movingLeft && this.atEnd;

        // Abort and let the parent slideshow handle the drag if we're moving in a direction where nested slideshow can't move
        if (isNested && cannotMoveInDirection) {
          controller.abort();
          return;
        }
        this.suspend();
        this.setAttribute('dragging', '');
      }

      // Stop the event from bubbling up to parent slideshow components
      event.stopImmediatePropagation();
      const now = performance.now();
      const delta = previous - current;
      const timeDelta = now - previousTime;
      velocity = timeDelta > 0 ? Math.round(delta / timeDelta * 1000) : velocity;
      previousTime = now;
      previous = current;
      distanceTravelled += Math.abs(delta);
      this.#scroll.by(delta, {
        instant: true
      });
    };

    /**
    * Handles the 'pointerup' event to stop dragging slides.
    * @param {PointerEvent} event - The pointerup event.
    */
    const onPointerUp = async event => {
      controller.abort();
      const {
        current,
        slides
      } = this;
      const {
        scroller
      } = this.refs;
      this.#dragging = false;
      if (!slides?.length || !scroller) return;
      const direction = Math.sign(velocity);
      const next = this.#sync();
      const modifier = current !== next || Math.abs(velocity) < 10 || distanceTravelled < 10 ? 0 : direction;
      const requestedIndex = next + modifier;
      const wrapsToEndInInfinite = this.infinite && requestedIndex < 0;
      const wrapsToStartInInfinite = this.infinite && requestedIndex > slides.length - 1;
      const newIndex = this.infinite ? requestedIndex < 0 ? slides.length - 1 : requestedIndex > slides.length - 1 ? 0 : requestedIndex : (0,_theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .clamp */ .qE)(requestedIndex, 0, slides.length - 1);
      let wrappedInInfinite = false;
      const newSlide = slides[newIndex];
      const currentIndex = this.current;
      if (!newSlide) throw new Error(`Slide not found at index ${newIndex}`);
      this.removeAttribute('dragging');
      this.releasePointerCapture(event.pointerId);
      if (wrapsToEndInInfinite) {
        wrappedInInfinite = true;
        this.#scroll.snap = true;
        await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        if (this.refs.previous) {
          this.refs.previous.click();
        } else {
          await this.previous(event, {
            animate: true
          });
        }
      } else if (wrapsToStartInInfinite) {
        wrappedInInfinite = true;
        this.#scroll.snap = true;
        await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        if (this.refs.next) {
          this.refs.next.click();
        } else {
          await this.next(event, {
            animate: true
          });
        }
      } else {
        this.#scroll.to(newSlide);
        this.#centerSelectedThumbnail(newIndex);
        this.dispatchEvent(new _theme_events__WEBPACK_IMPORTED_MODULE_3__/* .SlideshowSelectEvent */ .$b({
          index: newIndex,
          previousIndex: currentIndex,
          userInitiated: true,
          trigger: 'drag',
          slide: newSlide,
          id: newSlide.getAttribute('slide-id')
        }));
        this.current = newIndex;
        await this.#scroll.finished;
      }

      // It's possible that the user started dragging again before the scroll finished
      if (this.#dragging) return;
      if (wrappedInInfinite) {
        const activeSlide = this.slides?.[this.current];
        if (activeSlide?.querySelector('iframe')) {
          this.#scroll.to(activeSlide, {
            instant: true
          });
        }
      }
      this.#scroll.snap = true;
      this.resume();
    };
    this.#scroll.snap = false;
    document.addEventListener('pointermove', onPointerMove, {
      signal
    });
    document.addEventListener('pointerup', onPointerUp, {
      signal
    });
    document.addEventListener('pointercancel', onPointerUp, {
      signal
    });
    document.addEventListener('pointercapturelost', onPointerUp, {
      signal
    });
  };
  #handlePointerEnter = () => {
    this.setAttribute('actioned', '');
  };
  get slides() {
    return this.refs.slides?.filter(slide => !slide.hasAttribute('hidden') || slide.hasAttribute('reveal'));
  }

  /**
  * The initial slide index.
  * @type {number}
  */
  get initialSlideIndex() {
    const initialSlide = this.getAttribute('initial-slide');
    if (initialSlide == null) return 0;
    return parseInt(initialSlide, 10);
  }

  /**
  * Pause the slideshow when the page is hidden.
  */
  #handleVisibilityChange = () => document.hidden ? this.suspend() : this.resume();

  /**
  * Permanently pauses autoplay when keyboard focus enters a slideshow configured with pause-on-focus.
  */
  #handleFocusIn = event => {
    if (!this.pauseOnFocus || !this.autoplay) return;
    if (!(event.target instanceof HTMLElement) || !event.target.matches(':focus-visible')) return;
    this.pause();
  };
  #canAutoplayInCurrentContext() {
    if (!this.autoplayWhenParentDialogOpen) return true;
    if (!(this.#parentDialog instanceof HTMLDialogElement)) return true;
    return this.#parentDialog.open;
  }
  #setupParentDialogAutoplayGuard() {
    if (!this.autoplayWhenParentDialogOpen) return;
    this.#teardownParentDialogAutoplayGuard();
    const parentDialog = this.closest('dialog');
    if (!(parentDialog instanceof HTMLDialogElement)) return;
    this.#parentDialog = parentDialog;
    this.#parentDialogAutoplayObserver = new MutationObserver(entries => {
      for (const entry of entries) {
        if (entry.type !== 'attributes' || entry.attributeName !== 'open') continue;
        if (parentDialog.open) {
          this.resume();
        } else {
          this.suspend();
        }
        break;
      }
    });
    this.#parentDialogAutoplayObserver.observe(parentDialog, {
      attributes: true,
      attributeFilter: ['open']
    });
  }
  #teardownParentDialogAutoplayGuard() {
    this.#parentDialogAutoplayObserver?.disconnect();
    this.#parentDialogAutoplayObserver = null;
    this.#parentDialog = null;
  }

  /**
   * Whether slides overflow the visible scroller area.
   * Uses slide boxes rather than scrollWidth so gutter padding does not count as overflow.
   * @returns {boolean}
   */
  #hasOverflow() {
    const {
      scroller
    } = this.refs;
    const slides = this.slides;
    if (!scroller || !slides?.length) return false;
    const EPSILON = 1;
    const scrollerRect = scroller.getBoundingClientRect();
    if (scrollerRect.width === 0) return false;
    const firstRect = slides[0]?.getBoundingClientRect();
    const lastRect = slides[slides.length - 1]?.getBoundingClientRect();
    if (!firstRect || !lastRect || firstRect.width === 0 && lastRect.width === 0) {
      return scroller.scrollWidth > scroller.clientWidth + EPSILON;
    }
    const minLeft = Math.min(firstRect.left, lastRect.left);
    const maxRight = Math.max(firstRect.right, lastRect.right);
    return minLeft < scrollerRect.left - EPSILON || maxRight > scrollerRect.right + EPSILON;
  }
  #updateControlsVisibility() {
    const {
      scroller,
      slideshowControls
    } = this.refs;
    if (!scroller) return;
    const controls = new Set(this.querySelectorAll(':scope > slideshow-container > slideshow-arrows, :scope > slideshow-controls'));
    // A single slide has nothing to navigate to: skip #hasOverflow(), whose forced layout per
    // slideshow is costly while dozens of product cards connect during page load.
    const shouldHideControls = (this.slides?.length || 0) <= 1 || (this.classList.contains('slideshow--nested-passthrough') ? !_theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueryLarge */ .GO.matches : !this.#hasOverflow());
    if (slideshowControls instanceof HTMLElement) {
      controls.add(slideshowControls);
    }
    for (const control of controls) {
      if (control instanceof HTMLElement) {
        control.hidden = shouldHideControls;
      }
    }
  }

  /**
  * Setup IntersectionObserver for efficient visibility tracking of slides
  */
  #setupIntersectionObserver() {
    const {
      slides,
      scroller
    } = this.refs;
    if (!slides?.length) return;
    if (this.#intersectionObserver) {
      this.#intersectionObserver.disconnect();
    }
    this.#intersectionObserver = new IntersectionObserver(entries => {
      const allEntries = [...entries, ...(this.#intersectionObserver ? this.#intersectionObserver.takeRecords() : [])];
      for (const entry of allEntries) {
        const slide = /** @type {HTMLElement} */entry.target;
        const isCurrentlyVisible = this.#visibleSlides.includes(slide);
        const shouldBeVisible = entry.intersectionRatio >= SLIDE_VISIBLITY_THRESHOLD;
        if (entry.isIntersecting) {
          this.#intersectingSlides.add(slide);
        } else {
          this.#intersectingSlides.delete(slide);
        }
        if (shouldBeVisible && !isCurrentlyVisible) {
          this.#visibleSlides.push(slide);
        } else if (!shouldBeVisible && isCurrentlyVisible) {
          const index = this.#visibleSlides.indexOf(slide);
          if (index > -1) {
            this.#visibleSlides.splice(index, 1);
          }
        }
      }
      this.#visibleSlides.sort((a, b) => slides.indexOf(a) - slides.indexOf(b));
      this.#updateVisibleSlides();
    }, {
      root: scroller,
      // Include 0 so peeking product cards stay paintable on iOS (0.7 alone
      // treats a 30–40% visible slide as non-intersecting and hides its images).
      threshold: [0, SLIDE_VISIBLITY_THRESHOLD],
      // Add small margin to account for sub-pixel rendering
      rootMargin: '1px'
    });

    // Observe all slides - observer will fire initial callback asynchronously
    slides.forEach(slide => {
      this.#intersectionObserver?.observe(slide);
    });
  }

  /**
  * Centers the selected thumbnail in the thumbnails container
  * @param {number} index - The index of the selected thumbnail
  * @param {ScrollBehavior} [behavior] - The scroll behavior.
  */
  #centerSelectedThumbnail(index, behavior = 'smooth') {
    const selectedThumbnail = this.refs.thumbnails?.[index];
    if (!selectedThumbnail) return;
    const {
      thumbnailsContainer
    } = this.refs;
    if (!thumbnailsContainer || !(thumbnailsContainer instanceof HTMLElement)) return;
    const {
      slideshowControls
    } = this.refs;
    if (!slideshowControls || !(slideshowControls instanceof HTMLElement)) return;
    (0,_theme_scrolling__WEBPACK_IMPORTED_MODULE_2__/* .scrollIntoView */ .R)(selectedThumbnail, {
      ancestor: thumbnailsContainer,
      behavior,
      block: 'center',
      inline: 'center'
    });
  }
  #updateVisibleSlides() {
    const {
      slides
    } = this;
    if (!slides || !slides.length) return 0;
    if (this.classList.contains('slideshow--nested-passthrough')) {
      this.#keepNestedCurrentSlideVisible();
      return 1;
    }
    const visibleSlides = this.visibleSlides;

    // Native mobile carousels: toggling inert during snap aborts iOS momentum.
    if (this.hasAttribute('native-drag-mobile') && !_theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueryLarge */ .GO.matches) {
      return visibleSlides.length || 1;
    }

    // Batch writes to the DOM
    _theme_utilities__WEBPACK_IMPORTED_MODULE_1__/* .scheduler */ .ck.schedule(() => {
      // iOS nested scrollers can report zero intersections; never hide the current image.
      if (this.#intersectingSlides.size === 0) {
        const currentSlide = slides[this.current] || slides[0];
        currentSlide?.removeAttribute('inert');
        this.#ensureSlideImagesLoad(currentSlide);
        return;
      }

      // Update inert based on any visible pixel (not the 0.7 "current" threshold).
      slides.forEach(slide => {
        const isIntersecting = this.#intersectingSlides.has(slide);
        if (isIntersecting) {
          const wasInert = slide.hasAttribute('inert');
          slide.removeAttribute('inert');
          if (wasInert) this.#ensureSlideImagesLoad(slide);
        } else {
          slide.setAttribute('inert', '');
        }
      });
    });
    return visibleSlides.length;
  }

  /**
  * Applies per-slide controls icon color for arrows and controls.
  * @param {number} index
  */
  #applyActiveSlideControlsIconColor(index) {
    const slide = this.slides?.[index];
    const controlsIconColor = slide?.getAttribute('data-controls-icon-color');
    if (controlsIconColor) {
      this.style.setProperty('--slide-controls-icon-color', controlsIconColor);
      this.setAttribute('slide-controls-icon-color', '');
      return;
    }
    this.style.removeProperty('--slide-controls-icon-color');
    this.removeAttribute('slide-controls-icon-color');
  }
}
if (!customElements.get('slideshow-component')) {
  customElements.define('slideshow-component', Slideshow);
}
var __webpack_exports__Slideshow = __webpack_exports__.b;
export { __webpack_exports__Slideshow as Slideshow };
